import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

// Landing page for the redirect Google (via our backend) sends the browser
// back to: /auth/google/callback?token=... (or ?error=...).
const GoogleAuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loginWithToken } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error || !token) {
      toast.error('Google sign-in failed. Please try again.');
      navigate('/login', { replace: true });
      return;
    }

    loginWithToken(token)
      .then((user) => {
        toast.success('Signed in with Google!');
        if (user.role === 'influencer') navigate('/influencer/dashboard', { replace: true });
        else if (user.role === 'partner') navigate('/partner', { replace: true });
        else if (user.role === 'admin' || user.role === 'superadmin') navigate('/admin', { replace: true });
        else navigate('/dashboard', { replace: true });
      })
      .catch(() => {
        toast.error('Google sign-in failed. Please try again.');
        navigate('/login', { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="flex flex-col items-center gap-3 text-gray-600">
        <Loader2 className="h-8 w-8 animate-spin" />
        <p className="text-sm">Signing you in with Google...</p>
      </div>
    </div>
  );
};

export default GoogleAuthCallback;
